// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
export const spot = {
  button: {
    tel: '電 話',
    web: 'Web',
  },
  info_null: 'なし',
};
